module.exports = __webpack_public_path__ + "img/onDemand_bottle_right.d8bcf850.png";